import { useState } from "react";
import { Layout } from "antd";

import PageScoreCardFormContent from "./components/PageScoreCardFormContent";

export default function PageScoreCardForm() {
	const [isSendMyScoreCard, setIsSendMyScoreCard] = useState(false);

	return (
		<Layout.Content className={isSendMyScoreCard ? "sent" : ""}>
			<div className="main-content">
				<PageScoreCardFormContent
					isSendMyScoreCard={isSendMyScoreCard}
					setIsSendMyScoreCard={setIsSendMyScoreCard}
				/>
			</div>
		</Layout.Content>
	);
}
